export const redirects = {
  protectedRoute: '/checker',
  unprotectedRoute: '/',
};
